import { render, staticRenderFns } from "./ProjectListPage.vue?vue&type=template&id=6a6cc087&"
import script from "./ProjectListPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports